import { ReactNode } from 'react';
import styled from 'styled-components';

import { SBHorizontal, Vertical } from 'atoms/layout/flex';
import { HeadlineM } from 'atoms/typography';

const Root = styled(Vertical).attrs({ gap: 0 })`
  width: 100%;
  border-radius: 16px;
  padding-block: var(--unit);
  background: var(--c-nd-50);
  overflow: hidden;
`;
const StyledSBHorizontal = styled(SBHorizontal)`
  padding: var(--unit) var(--double-unit);
`;

type Props = {
  title: ReactNode;
  actions?: ReactNode;
  children: ReactNode;
};

export const Section = ({ title, actions, children }: Props) => {
  return (
    <Root>
      <StyledSBHorizontal>
        <HeadlineM bold>{title}</HeadlineM>
        {!!actions && <div>{actions}</div>}
      </StyledSBHorizontal>
      {children}
    </Root>
  );
};
